/**
 * Guards for cleaner React Query keys and enabled flags.
 * URL params / router timing can yield the literal string "undefined", which is truthy but invalid.
 */

/** True when id is a non-empty real identifier (not literal "undefined" / "null"). */
export function isValidCleanerEntityId(id: string | undefined | null): id is string {
  if (id == null || typeof id !== "string") return false;
  const t = id.trim();
  if (t.length === 0) return false;
  const lower = t.toLowerCase();
  if (lower === "undefined" || lower === "null") return false;
  return true;
}

/** Shell / section-detail queries need property (location), section, and org. */
export function areCleanerShellQueryParamsReady(
  propertyId: string | undefined,
  sectionId: string | undefined,
  orgId: string | undefined,
): boolean {
  return (
    isValidCleanerEntityId(propertyId) &&
    isValidCleanerEntityId(sectionId) &&
    isValidCleanerEntityId(orgId)
  );
}
